<template>
  <div :class="modalClass" tabindex="-1" role="dialog" id="seatPickerModal">
    <div class="modal-dialog" role="document" id="seatPickerModalDialog">
      <div class="modal-content" :style="borderRadius ? 'border-radius: ' + borderRadius + 'px' : ''">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" :aria-label="_('Close')" v-on:click="close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" v-if="maxSeats == 1">{{ _('Select a seat') }}</h4>
          <h4 class="modal-title" v-else>{{ _('Select seats') }}</h4>
        </div>
        <div class="modal-body" id="seatPickerModalBody">
          <div id="seatPicker" style="width: 100%; height: 100%">
            <div :class="seatClass(seat.id)" v-for="seat in seats" v-on:click="toggleSeat(seat.id)">
              <div class="seat-text seat-header">{{ seat.header }}</div>
              <div class="seat-text seat-title" v-if="seat.title">{{ seat.title }}</div>
              <div class="seat-text seat-title" v-else>{{ seat.id }}</div>
              <div class="seat-text seat-footer">{{ seat.footer }}</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="modal-footer" v-if="showButtons">
          <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="close">{{ _('Cancel') }}</button>
          <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="select" v-if="maxSeats > 1">{{ _('OK') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  props: ['showButtons', 'column', 'borderRadius', 'theme', 'seats', 'selectedSeats', 'maxSeats'],
  data () {
    return {
      seatNumbersHidden: false,
      modalVisible: false
    }
  },
  computed: {
    ...mapGetters(['clientid', 'pos']),
    activeTheme () {
      if (this.theme) {
        return this.theme
      }
      return 'light'
    },
    modalClass () {
      return 'modal fade in show ' + this.activeTheme
    },
    myComponentId () {
      return this.column ? this.column.identifier + '-' + this.column.component.id + '-seatpicker' : null
    }
  },
  methods: {
    seatClass (seatId) {
      let c = 'seat'
      if (this.selectedSeats && this.selectedSeats.indexOf(seatId) !== -1) {
        c += ' selected'
      }
      return c
    },
    close () {
      this.$emit('closeModal')
    },
    select () {
      this.$emit('confirmSelection')
    },
    toggleSeat (seatId) {
      if (this.selectedSeats && this.selectedSeats.indexOf(seatId) !== -1) {
        this.$emit('seatDeselected', seatId)
      } else {
        this.$emit('seatSelected', seatId)
        if (this.maxSeats === 1) {
          this.select()
        }
      }
    }
  }
}
</script>

<style scoped>
.clear {
  clear: both;
}
.seat {
  width: 70px;
  height: 70px;
  border: 1px #CCCCCC solid;
  border-radius: 5px;
  float: left;
  margin: 10px;
}
.seat.selected {
  background-color: #679F38;
  border-color: #4F792B;
  color: white;
}
.seat:hover {
  cursor: pointer;
}
.seat-text {
  text-align: center;
}
.seat-header, .seat-footer {
  font-size: 0.9em;
}
.seat-title {
  font-size: 1.2em;
  font-weight: bold;
}
.dark .modal-content {
  border-color: #111111;
  background-color: #222222;
}
.dark .modal-title {
  color: #98ADB8;
}
.dark .modal-header {
  border-bottom-color: #111111;
}
.dark .close {
  color: #ffffff;
}
</style>